/**
	alpha-xman默认兜底配置  (非特殊情况禁止改动)

*/

window.SCHD_COMS = window.SCHD_COMS || {}; 
window.SCHD_COMS.modsConfig = window.SCHD_COMS.modsConfig || {};

window.SCXmanConfig = window.SCXmanConfig || {
    enableKeepLogin : true,
    version: '1.0.2'
};
var xmanVersion = '20170725113031';
if( typeof(window.SCHD_COMS.modsConfig['xman']) === 'undefined'){
	window.SCHD_COMS.modsConfig['xman'] = {
		modLink:'sc-global-components/' + xmanVersion + '/entrances/xman/xman.css',
		modSrc:'sc-global-components/' + xmanVersion + '/entrances/xman/xman.js',
		modStandaloneSrc:'sc-global-components/' + xmanVersion + '/entrances/xman/standalone/xman.js'
	};
}
/**
    异步话xman 外壳容器对象
*/
var cookie = require('@alife/alpha-cookie/cookie');
var xmanLazy = function( config ){
      this.config = config;
      this._events = [];
      this._attrs = [];
      this._setMembers = [];
      this._sMembers = [];
      this._reloadDatas = [];
      this._setDatas = [];
      this._isInit = false;
      this.isXembed = config.isXembed;

};
xmanLazy.prototype = {

      
      on:function(key, callback){
        if(this._isInit && this.isValid() ){
          this.xmanObj.on(key, callback);
        }else{
          this._events.push({
              key:key,
              callback:callback
          });
        }
      },

      reloadData:function(name){
        if(this._isInit && this.isValid() ){
          this.xmanObj.reloadData(name);
        }else{
          this._reloadDatas.push(name);
        }
      },

      setData:function(name, data){
        if(this._isInit && this.isValid() ){
          this.xmanObj.setData(name, data);
        }else{
          this._setDatas.push({
              name:name,
              data:data
          });
        }
      },


      set:function(key, val){
        if(this._isInit && this.isValid() ){
          this.xmanObj.set(key, val);
        }else{
          this._attrs.push({
              key:key,
              val:val
          });
        }
      },

      get:function(key){
        if(this._isInit && this.isValid() ){
          return this.xmanObj.get(key);
        }else{
          return 0;
        }
      },

      setMember:function(key, key2, val){
        if(this._isInit && this.isValid() ){
          this.xmanObj.setMember(key, key2, val);
        }else{
          this._setMembers.push({
              key:key,
              key2:key2,
              val:val
          });
        }
      },

      switchMember:function(name){
        if(this._isInit && this.isValid() ){
          this.xmanObj.switchMember(name);
        }else{
          this._sMembers.push(name);
        }
      },

      isValid:function(){
        var ret = true;
        if( typeof(this.xmanObj) === 'undefined' ){
          ret = false;
        }else if( this.xmanObj.element === null ){
          ret = false;
        }
        return ret;
      },

      show:function(){

        window.SCHD_COMS.use(['xman'],function(){
            var SCXman =  window.SCHD_COMS.SCXman;
            if( SCXman && this.isValid() === false ){
              if( this.isXembed === false ){
                this.xmanObj = new SCXman.Popup(this.config);
              }else{
                this.xmanObj = new SCXman.Embed(this.config);
              }  
              this._isInit = true;
            }
            //还原事件注册
            if( this._events.length > 0 ){
              this._events.forEach(function(item,index){
                this.xmanObj.on(item.key, item.callback);
              }.bind(this));
              this._events = [];
            }
            //还原属性设置
            if( this._attrs.length > 0 ){
              this._attrs.forEach(function(item,index){
                this.xmanObj.set(item.key, item.val);
              }.bind(this));
              this._attrs = [];
            }
            //还原属性设置
            if( this._setMembers.length > 0 ){
              this._setMembers.forEach(function(item,index){
                this.xmanObj.setMember(item.key, item.key2, item.val);
              }.bind(this));
              this._setMembers = [];
            }
            // switchMember还原
            if( this._sMembers.length > 0 ){
              this._sMembers.forEach(function(name,index){
                this.xmanObj.switchMember(name);
              }.bind(this));
              this._sMembers = [];
            }
            // reloadData
            if( this._reloadDatas.length > 0 ){
              this._reloadDatas.forEach(function(name,index){
                this.xmanObj.reloadData(name);
              }.bind(this));
              this._reloadDatas = [];
            }
            // setData
            if( this._setDatas.length > 0 ){
              this._setDatas.forEach(function(item,index){
                this.xmanObj.setData(item.name, item.data);
              }.bind(this));
              this._setDatas = [];
            }
            
            if( this.xmanObj ){
                if( this.isXembed ){
                  this.xmanObj.render();
                }else{
                  this.xmanObj.show();
                }
            }
        }.bind(this));

        var pageUrl = window.location.host + window.location.pathname;
        this.goldLogDot({
            gmkey:'CLK',
            gokey:'pageurl=' + pageUrl
        });

      },

      render:function(){
          this.show();
      },

      hide:function(){
        if( this.xmanObj ){
            this.xmanObj.hide();
        }
      },

      destroy:function(){
        if( this.xmanObj ){
            this.xmanObj.destroy();
        }
      },

      isLoggedIn:function(){
            var usfCookieMap = {},
                isLoggedIn = false;
            if (cookie.get('xman_us_f')) {
                var usfCookieArr = cookie.get('xman_us_f').split('&');
                for (var i = usfCookieArr.length; i--;) {
                    var tempCookieArr = usfCookieArr[i].split('=');
                    usfCookieMap[tempCookieArr[0]] = tempCookieArr[1];
                }
            }
            var isLoginCookie = cookie.get('xman_us_t');
            // 是否登录
            if (isLoginCookie && isLoginCookie.indexOf('sign=y') !== -1) {
                isLoggedIn = true;
            } else {
                isLoggedIn = false;
            }
            return isLoggedIn;
      },

      goldLogDot:function( params ){
          if( typeof(goldlog) !== 'undefined' && typeof(goldlog.record) === 'function' ){
              params.gokey = params.gokey || '';
              goldlog.record( '/sc.globalxman.wronguse', params.gmkey, params.gokey, 'H1479648432');
          }
      }
};

var xman = {
  Popup : function(config){
      config = config || {};
      config.isXembed = false;
      return new xmanLazy(config);
  },
  Embed : function(config){
      config = config || {};
      config.isXembed = true;
      return new xmanLazy(config);
  },
  version: {},
  scVersion: 1.3,
  isPreInit: false
};


module.exports =  xman;	